import React from "react";

import groupworship from "../assets/20240728_141833~2.jpg";
import congregation from "../assets/congregation.jpg";
import littleflockimg1 from "../assets/littleflockimg1.jpg";
import menofchurch from "../assets/menofchurch.jpg";
import pastorjose from "../assets/pastorjose.jpg";
import pastormission from "../assets/pastormission.jpg";
import worship from "../assets/worship.jpg";
import apostle1 from "../assets/apostle1.jpg";
import apostle2 from "../assets/Apostle2.jpg";
import congregationpraying from "../assets/congregation_praying.jpg";
import prayer1 from "../assets/prayer1.jpg";

const photos = [
  { src: pastorjose, alt: "Pastor Jose ministering during a service", featured: true },
  { src: worship, alt: "The congregation standing in worship" },
  { src: littleflockimg1, alt: "Hands raised in praise" },
  { src: congregation, alt: "Members listening to the message" },
  { src: groupworship, alt: "Congregation worshipping with hands raised" },
  { src: congregationpraying, alt: "The church praying together" },
  { src: menofchurch, alt: "Men of the church gathered" },
  { src: pastormission, alt: "Pastor on a mission outreach" },
  { src: apostle1, alt: "Apostolic ministry visit" },
  { src: apostle2, alt: "Fellowship after service" },
  { src: prayer1, alt: "A moment of personal prayer" },
];

const Gallery = () => {
  return (
    <section id="gallery" className="w-full bg-cream py-20 px-4 md:py-28">
      <div className="mx-auto max-w-[1240px]">
        <div className="mx-auto max-w-2xl text-center">
          <p className="section-label">Our Family</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-maroon sm:text-4xl">
            Gallery of the Saints
          </h2>
          <p className="mt-4 text-ink/70">
            Moments of worship, prayer and fellowship from our congregation.
          </p>
        </div>

        <div className="mt-12 grid auto-rows-[160px] grid-cols-2 gap-3 sm:auto-rows-[190px] sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {photos.map((p, i) => (
            <div
              key={i}
              className={`group overflow-hidden rounded-xl shadow-md ${
                p.featured ? "col-span-2 row-span-2" : ""
              }`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
